import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import profileImage from "../../assets/images/profile/IMG.png";
import { Modal } from "react-bootstrap";
import axios, { PublicKey } from "../../API/axios";
import toast from "react-hot-toast";
import UpdateCandidateProfile from "./UpdateCandidateProfile";
import UpdateInstituteProfile from "./UpdateInstituteProfile";
import UpdateCompanyProfile from "./UpdateCompanyProfile";
import UpdateRecruiterProfile from "./UpdateRecruiterProfile";
import CloseSharpIcon from '@mui/icons-material/CloseSharp';


const Setting = () => {
  const sessionId = localStorage.getItem("sessionId");
  const module = localStorage.getItem("Module"); 

  // ..........Confim delete account..........
  const [showPass, setShowPass] = useState(false);
  const [showPass1, setShowPass1] = useState(false);

  const [showPass3, setShowPass3] = useState(false);
  const [showPass4, setShowPass4] = useState(false);

  // .................................A ....................................

  const [displays, setDisplays] = useState(false); 

  // ............................... A ......................................

  // ..........Confim delete account..........
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showDeactivate, setShowDeactivate] = useState(false);
  
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleShowDeactivate = () => setShowDeactivate(true);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleClose = () => {
    setShow(false);
    setShowDeactivate(false);
    setShow(false);
  };

//   Modal for unblock
const [ unblockId, setUnblockId ] = useState(false);
const [showUnblock, setShowUnblock] = useState(false);
  const handleShowUnblock = () => setShowUnblock(true);
  const handleCloseUnblock = () => {
    setShowUnblock(false);
  }

//   Modal for unfollow
const [ unfollowId, setUnfollowId ] = useState(false);
const [showUnfollow, setShowUnfllow] = useState(false);

  const handleShowUnfollow = () => setShowUnfllow(true);
  const handleCloseUnfollow = () => {
    setShowUnfllow(false);
  }

  const handleDelete = async () => {
    try {
      const response = await axios.post(
        `/Account/DeleteAccount?sessionId=${sessionId}`,
        {
          headers: {
            PublicKey,
          },
        }
      );
      console.log("res", response);
      toast.success(response.data.message);
      closeModal();

      if (response.ok) {
        console.log("Account deleted successfully");
        closeModal();
      } else {
        console.error("Failed to delete account");
      }
    } catch (error) {
      console.error("Error deleting account:", error);
      toast.error(error.response.data.message);
    }
  };

  const handleDeactivate = async () => {
    try {
      const response = await axios.post(
        `/Account/DeactivateAccount?sessionId=${sessionId}`,
        {
          headers: {
            PublicKey,
          },
        }
      );
      console.log("res", response);
      toast.success(response.data.message);
      handleClose();
    } catch (error) {
      console.error("Error deleting account:", error);
      toast.error(error.response.data.message);
    }
  };

  // ...............................CHANGE PASSWORD Start.......................................
 
  const [oldpassword, setOldPassword] = useState("");
  const [newpassword, setNewPassword] = useState("");
  const [confirmpassword, setconfirmPassword] = useState("");

  const ChangePassword = async (e, responseData) => {
    e.preventDefault();
    console.log("hjkhjdxh");

    const responseData2 = {
      sessionId: sessionId,
      oldPassword: oldpassword,
      newPassword: newpassword,
      confirmPassword: confirmpassword,
    };
    console.log("login", responseData2);

    try {
      setDisplays(true);
      if (oldpassword && newpassword && confirmpassword !== "") {
        const res = await axios.post("/Account/ChangePassword", responseData2, {
          headers: {
            PublicKey,
          },
        });

        console.log("ghgh", res);
        toast.success(res.data.message);
        setOldPassword("");
        setNewPassword("");
        setconfirmPassword("");
        setDisplays(false);
        // navigate('/SetNewPassword')
      } else {
        toast.error("please enter required fields!");
        // { position: "top-center" }
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        toast.warning(error.response.data.message);
      } else {
        toast.error(error.response.data.message);
      }
      // console.log(error);
    }
  };

  // ...............................CHANGE PASSWORD End.......................................

  //   const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [followerListError, setfollowerListError] = useState(false);
  const [followedList, setFollowedList] = useState([]);

  const getFollowedList = () => { 
    const data = {
      sessionId: sessionId,
    };
    axios
      .post(`/Feature/GetFollowedCompanies`, data)
      .then((response) => {
        setIsLoading(false);
        console.log("getFollowerList", response.data.responseData);
        const res = response.data.responseData;
        setFollowedList(res);
      })
      .catch((error) => {
        if (error.response && error.response.status === 404) {
          setfollowerListError(true);
        } else {
          console.log(error);
        }
        setIsLoading(false);
      });
  };
  useEffect(() => {
    getFollowedList();
  }, []);
  console.log("followedList", followedList);

  //   Block user
  const [blockedList, setBlockedList] = useState([]);

  const getBlockedList = () => { 
    const data = {
      sessionId: sessionId,
    };
    axios
      .post(`/Feature/GetBlockedCompanies`, data)
      .then((response) => {
        setIsLoading(false);
        console.log("getFollowerList", response.data.responseData);
        const res = response.data.responseData;
        setBlockedList(res);
        console.log("blockedList", res);
      })
      .catch((error) => {
        if (error.response && error.response.status === 404) {
          setfollowerListError(true);
        } else {
          console.log(error);
        }
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getBlockedList();
  }, []);

  // UnFollow user

  const UnFollowUser = async (id) => {
    const data = {
      sessionId: sessionId,
      compUID: unfollowId,
    };
    try {
      await axios
        .post("/CandidateAction/UnfollowCompany", data)
        .then((resData) => {
          console.log("resDataaaaa", resData);
          getBlockedList();
		  setShowUnfllow(false);
          toast.success(resData.data.message);
        });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        toast.warning(e.response.data.message);
      } else {
        toast.error(e.response.data.message);
      }
    }
  };

  // UnFollow user

  const UnBlockUser = async (id) => { 

    const data = {
      sessionId: sessionId,
      compUID: unblockId,
    };
    try {
      await axios
        .post("/CandidateAction/UnblockCompany", data)
        .then((resData) => {
          console.log("unblock user", resData.data.message);
          getFollowedList();
		  setShowUnblock(false);
          toast.success(resData.data.message);
        });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        toast.warning(e.response.data.message);
      } else {
        toast.error(e.response.data.message);
      }
    }
  };

  return (
    <>
      <section className="term-section settings ">
        <div className="container">
          <Tabs className="row tf-tab">
            <div className="col-lg-4">
              <TabList className="menu-tab tab-term po-sticky">
                <Tab className="ct-tab">1. Profile </Tab>
                <Tab className="ct-tab">2. Blocked Users</Tab>
                <Tab className="ct-tab">3. Accounts</Tab>
                <Tab className="ct-tab">4. Change Password</Tab>
                <Tab className="ct-tab">5. Followed Users</Tab>
              </TabList>
            </div>
            <div className="col-lg-8">
              <div className="content-tab">
                <TabPanel className="term-content animation-tab p-4">
                  {module === "Candidate" ? (
                    <UpdateCandidateProfile />
                  ) : module === "Institution" ? (
                    <UpdateInstituteProfile />
                  ) : module === "Company" ? (
                    <UpdateCompanyProfile />
                  ) : module === "Recruiter" ? (
                    <UpdateRecruiterProfile />
                  ) : (
                    <UpdateCandidateProfile />
                  )}
                </TabPanel>

                <TabPanel className="term-content animation-tab p-4 mb-5">
                  <section className="account-section pt-1">
                    <h6>Blocked Users</h6>

                    {/* {data.slice(0, 6).map((idx) => ( */}
                    {blockedList
                     .filter((item) => !item.isDeleted)
                     .map((item) => {
                      return (
                        <div className="col-lg-12">
                          <div className="employer-block style-2">
                            <div className="inner-box">
                              <div className="logo-company">
                                <img
                                  src={item.logo} 
                                  alt="jobtex"
                                  style={{ borderRadius: "50%" }}
                                />
                              </div>
                              <div className="box-content">
                                <h3>
                                  <Link to="/Employersingle_v1">
                                    {item.compName}
                                  </Link> 
                                </h3>
                                <p className="info"> 
                                  {item.title}
                                </p>
                              </div>
                              <div className="button-readmore"> 
                                <button
                                  className="btn-employer"
                                  onClick={()=>{
                                  handleShowUnblock()
                                  setUnblockId(item.compUid)
                                  }}
                                >
                                  {" "}
                                  UnBlock
                                  {/* {idx.job} */}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}

                    {/* ))} */}
                  </section>
                </TabPanel>

                <TabPanel className="term-content animation-tab p-4 mb-5">
                  <section className="account-section pt-1">
                    <h6>Manage Account</h6>

                    <div className="account-section deactivate-account p-3">
                      <h6>Deactivate your account</h6>
                      <p>This will deactivate your account</p>
                      <ul>
                        <li>
                          After successful login, the deactivated account will
                          be activated and accessible or viewable
                        </li>
                      </ul>
                      <button onClick={handleShowDeactivate}>
                        Deactivate account
                      </button>
                    </div>

                    {/* Delete Account Section */}
                    <div className="account-section delete-account p-3 mt-4">
                      <h6>Delete your account</h6>
                      <p>This will delete your account</p>
                      <ul>
                        <li>
                          You can restore your account if it was deleted by
                          mistake within 45 days after deletion.
                        </li>
                      </ul>
                      <button onClick={handleShow}>Delete account</button>
                    </div>
                  </section>
                </TabPanel>
                <TabPanel className="term-content animation-tab p-4 mb-5">
                  {/* <section className="account-section pt-1"> */}
                  <h6>Change Password</h6>

                  <div className="profile-setting-form changePassword">
                    <div className="ip mb-2">
                      <label>Old Password</label>
                      <div className="inputs-group auth-pass-inputgroup">
                        <input
                          type={showPass ? "text" : "password"}
                          className="input-form password-input"
                          placeholder="Old Password"
                          id="password-input"
                          required
                          onChange={(e) => setOldPassword(e.target.value)}
                          // onChange={(e) => { setEmail(e.target.value) }}

                          value={oldpassword}
                          invalid={displays && oldpassword === ""}
                        />
                        {displays && !oldpassword ? (
                          <span className="error_msg_lbl text-red">
                            Enter New Password{" "}
                          </span>
                        ) : null}

                        <Link
                          className={`password-addon ${
                            showPass ? "icon-eye" : "icon-eye-off"
                          }`}
                          id="password-addon"
                          onClick={() => setShowPass(!showPass)}
                        />
                      </div>
                    </div>
                    <div className="ip mb-2">
                      <label>New Password</label>
                      <div className="inputs-group auth-pass-inputgroup">
                        <input
                          type={showPass3 ? "text" : "password"}
                          className="input-form password-input"
                          placeholder="New Password"
                          id="password-input"
                          required
                          onChange={(e) => setNewPassword(e.target.value)}
                          // onChange={(e) => { setEmail(e.target.value) }}

                          value={newpassword}
                          invalid={displays && newpassword === ""}
                        />
                        {displays && !newpassword ? (
                          <span className="error_msg_lbl text-red">
                            Enter New Password{" "}
                          </span>
                        ) : null}

                        <Link
                          className={`password-addon ${
                            showPass3 ? "icon-eye" : "icon-eye-off"
                          }`}
                          id="password-addon"
                          onClick={() => setShowPass3(!showPass3)}
                        />
                      </div>
                    </div>
                    <div className="ip">
                      <label>Confirm Password</label>
                      <div className="inputs-group auth-pass-inputgroup">
                        <input
                          type={showPass1 ? "text" : "password"}
                          className="input-form password-input"
                          placeholder="Confirm Password"
                          id="password-input"
                          required
                          // onChange={(e) => { setEmail(e.target.value) }}

                          onChange={(e) => setconfirmPassword(e.target.value)}
                          value={confirmpassword}
                          invalid={displays && confirmpassword === ""}
                        />
                        {displays && !confirmpassword ? (
                          <span className="error_msg_lbl text-red">
                            Enter Confirm Password{" "}
                          </span>
                        ) : null}

                        <Link
                          className={`password-addon ${
                            showPass1 ? "icon-eye" : "icon-eye-off"
                          }`}
                          id="password-addon"
                          onClick={() => setShowPass1(!showPass1)}
                        />
                      </div>
                    </div>

                    <button
                      className="btn btn-primary"
                      onClick={(e) => ChangePassword(e)}
                    >
                      Submit
                    </button>
                  </div>
                  {/* </section> */}
                </TabPanel>
                <TabPanel className="term-content animation-tab p-4 mb-5">
                  <section className="account-section pt-1">
                    <h6>Followed Users</h6>

                    {/* {data.slice(0, 6).map((idx) => ( */}
                    {followedList
                     .filter((item) => !item.isDeleted)
                     .map((item) => {
                      return (
                        <div className="col-lg-12">
                          <div className="employer-block style-2">
                            <div className="inner-box">
                              <div className="logo-company">
                                <img
                                  //   src={item.logo}
                                  src={item.logo}
                                  alt="jobtex"
                                  style={{ borderRadius: "50%" }}
                                />
                              </div>
                              <div className="box-content">
                                <h3>
                                  <Link to="/Employersingle_v1">
                                  {item.compName}
                                  </Link> 
                                </h3>
                                <p className="info">
                                {item.title}

                                  {/* <span className="icon-map-pin"></span> */}
                                </p>
                              </div>
                              <div className="button-readmore">
                                <button
                                  className="btn-employer"
                                  onClick={() => 
                                      {
                                      handleShowUnfollow()
                                      setUnfollowId(item.compUid)
                                      }
                                      
                                    }
                                >
                                  {" "}
                                  UnFollow
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}

                    {/* ))} */}
                  </section>
                </TabPanel>
              </div>
            </div>
          </Tabs>
        </div>
      </section>

      {/* .......deactivate modal....  */}

      <Modal show={showDeactivate} onHide={handleClose} centered>
        <Modal.Header >
          <Modal.Title>Confirm Deactivation</Modal.Title>
          <CloseSharpIcon className="pointer" onClick={handleClose} />
        </Modal.Header>
        <Modal.Body className="settings">
        <div className=" mb-3">
            <p>Are you sure you want to deactivate your account?</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button onClick={handleDeactivate} className="btn btn-danger me-2">
            Confirm Deactivate
          </button>
          <button onClick={handleClose} className="btn btn-secondary">
            Cancel
          </button>
        </Modal.Footer>
      </Modal>

      {/* .......delete modal....  */}

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header >
          <Modal.Title>Confirm Delete</Modal.Title>
          <CloseSharpIcon className="pointer" onClick={handleClose} />
        </Modal.Header>
        <Modal.Body className="settings">
        <div className=" mb-3">
            <p>Are you sure you want to delete your account?</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button onClick={handleDelete} className="btn btn-danger me-2">
            Confirm Delete
          </button>
          <button onClick={handleClose} className="btn btn-secondary">
            Cancel
          </button>
        </Modal.Footer>
      </Modal>

      {/* .......unblock modal....  */}

      <Modal show={showUnblock} onHide={handleCloseUnblock} centered>
        <Modal.Header >
          <Modal.Title>Confirm Unblock</Modal.Title>
          <CloseSharpIcon className="pointer" onClick={handleCloseUnblock} />
        </Modal.Header>
        <Modal.Body className="settings">
        <div className=" mb-3">
            <p>Are you sure want to unblock?</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button onClick={UnBlockUser} className="btn btn-danger me-2">
            Confirm unblock
          </button>
          <button onClick={handleCloseUnblock} className="btn btn-secondary">
            Cancel
          </button>
        </Modal.Footer>
      </Modal>

      {/* .......unfollow modal....  */}

      <Modal show={showUnfollow} onHide={handleCloseUnfollow} centered>
        <Modal.Header >
          <Modal.Title>Confirm Unfollow</Modal.Title>
          <CloseSharpIcon className="pointer" onClick={handleCloseUnfollow} />
        </Modal.Header>
        <Modal.Body className="settings">
        <div className=" mb-3">
            <p>Are you sure want to unfollow?</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button onClick={UnFollowUser} className="btn btn-danger me-2">
            Confirm Unfollow
          </button>
          <button onClick={handleCloseUnfollow} className="btn btn-secondary">
            Cancel
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Setting;
